<div class="aya-program-dates">
  <div class="aya-title">Program dates</div>
  <div class="aya-program-dates__table">
    <p-table [value]="programDatesBySchool">
      <ng-template pTemplate="header">
        <tr>
          <th rowspan="2">Start dates</th>
          <th [attr.colspan]="endDatesColumns?.length">End dates</th>
        </tr>
        <tr>
          <th *ngFor="let column of endDatesColumns">{{ column }} months</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-programDate>
        <tr>
          <td>{{ programDate?.startDate | lxOrdinalDate }}</td>
          <td *ngFor="let durationIndex of durationIndexes">
            {{ programDate?.endDates && programDate?.endDates[durationIndex]?.date | lxOrdinalDate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
